module.exports = __webpack_public_path__ + "img/2.ec82cca1.webp";